import styled from 'styled-components';
import { Paper } from '@material-ui/core';

import { px, fontFamilySize } from '../../contrib/ui';

export const TeamCardStyled = styled(Paper)`
  padding: ${px(10)} !important;
  margin-top: 0;
  position: relative;
  min-height: ${px(300)} !important;
  margin-bottom: ${px(10)};
  border: 1px solid transparent;

  .player-card,
  .empty-spot {
    margin-top: ${px(10)};
  }

  &-actions {
    position: absolute;
    top: ${px(10)};
    right: ${px(10)};

    button {
      height: ${px(30)};
      padding: ${px(5)} ${px(5)};
      .button__label {
        ${fontFamilySize('Heavy', 14)};
      }
    }
  }

  p.metadata {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin: 0;
    line-height: 1;

    span {
      display: inline-block;
      font-size: calc(var(--px) * 14);

      &.title {
        font-family: 'DINNextLTPro-Medium';
        color: var(--grey9b);
        width: calc(var(--px) * 100);
      }
      &.value {
        font-family: 'DINNextLTPro-Bold';
        color: var(--dark);
      }
    }

    .input-form-control {
      width: ${px(60)};
      margin-bottom: 0;
      .material-input.override {
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        min-height: 0 !important;
      }
    }
  }

  .team-members {
    margin: ${px(10)};
    border-top: 1px solid #eeeeef;
  }

  .edit-player-card {
    position: relative;

    background-color: var(--grey4a);

    h1 {
      font-family: 'DINNextLTPro-Heavy';
      font-size: calc(var(--px) * 22);
      color: white;
      text-align: center;
      margin: 0;
      max-width: 100%;
      margin-top: calc(var(--px) * 5);
    }
  }

  .open-spot {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    button {
      background-color: white;
    }
  }

  &.empty {
    border-color: var(--mainColor);
    border-width: 2px;
    border-style: dashed;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    span {
      font-family: 'DINNextLTPro-Bold';
      font-size: calc(var(--px) * 18);
      display: inline-block;

      &:nth-of-type(1) {
        text-align: center;
        font-size: calc(var(--px) * 28);

        width: calc(var(--px) * 30);
        height: calc(var(--px) * 30);

        margin-right: calc(var(--px) * 10);

        background-color: var(--mainColor);
        color: white;
        border-radius: calc(var(--px) * 50);
      }
      &:nth-of-type(2) {
        margin-top: calc(var(--px) * 5);
        color: var(--mainColor);
      }
    }

    &:hover {
      background-color: inherit;
      cursor: pointer;
    }
  }

  &.invalid {
    border: 1px solid var(--orange);
    position: relative;

    .team-card-header {
      width: 100%;
      margin-top: calc(var(--px) * -10);
      margin-left: calc(var(--px) * -10);
      margin-bottom: calc(var(--px) * 10);
      display: flex;
      flex-direction: row;
      align-items: center;
      height: calc(var(--px) * 40);

      .team-warning {
        --containerWidth: 40;
        --fontSize: 25;

        height: calc(var(--px) * var(--containerWidth));
        width: calc(var(--px) * var(--containerWidth));
        background-color: var(--orange);
        border-top-left-radius: calc(var(--px) * 2);
        margin-right: calc(var(--px) * 10);
        position: relative;

        &:before {
          margin-bottom: calc(var(--px) * 10);
          font-family: 'DINNextLTPro-Heavy';
          font-size: calc(var(--px) * var(--fontSize));
          line-height: calc(var(--px) * var(--fontSize));
          text-align: center;
          color: white;

          content: '!';
          position: absolute;
          width: calc(var(--px) * (var(--fontSize) + 5));
          padding-top: calc(var(--px) * 5);
          border: calc(var(--px) * 1) solid white;
          border-radius: calc(var(--px) * 50);
          left: calc(var(--px) * 3);
          top: calc(var(--px) * 3);
        }
      }

      h1.title {
        margin-bottom: 0;
      }

      h1.title,
      .team-warning {
        display: inline-block;
      }
    }
  }
`;
